const get_bin_config = (record = false, state = {}) => {
  let p_pmc = 0, p_pag = 0, p_ld2 = 0, p_ld3 = 0
  let Hint = ''
  let className = ''
  const editRecord =  record || state?.editRecord || false
  if(editRecord) {
    if (editRecord?.build_uld?.length > 0) {
      editRecord?.build_uld?.map((item) => {
        if (item?.type === 'PMC') {
          p_pmc++
        }
        if (item?.type === 'PAG' || item?.type === 'PAJ' || item?.type === 'RAP') {
          p_pag++
        }
        if (item?.type === 'LD2' || item?.type === 'DPA' || item?.type === 'DPE' || item?.type === 'DPL' || item?.type === 'DPN' || item?.type === 'LD4' || item?.type === 'LD8' || item?.type === 'FQA' || item?.type === 'DQL' || item?.type === 'DQP' || item?.type === 'DQF') {
          p_ld2++
        }
        if (item?.type === 'LD4' || item?.type === 'LD8' || item?.type === 'FQA' || item?.type === 'DQL' || item?.type === 'DQP' || item?.type === 'DQF') {
          p_ld2++
        }
        if (item?.type === 'LD3' || item?.type === 'AKE' || item?.type === 'AKN' || item?.type === 'AKX' || item?.type === 'AKY' || item?.type === 'RKN' || item?.type === 'PLA' || item?.type === 'FLA' || item?.type === 'PLB') {
          p_ld3++
        }
        if (item?.type === 'PLA' || item?.type === 'FLA' || item?.type === 'PLB') {
          p_ld3++
        }
      })
      if (!(state.editCargoP96 || editRecord?.cargo?.p96) && !(state.editCargoP88 || editRecord?.cargo?.p88) && !(state.editCargoLD2 || editRecord?.cargo?.ld2) && !(state.editCargoLD3 || editRecord?.cargo?.ld3)) {
        Hint = 'Max Bin Configuration missing'
        className = 'table-row-warning'
      } else {
        if (((state.editCargoP96 || editRecord?.cargo?.p96 || 0) >= p_pmc) && ((state.editCargoP88 || editRecord?.cargo?.p88 || 0) >= p_pag) && ((state.editCargoLD2 || editRecord?.cargo?.ld2 || 0) >= p_ld2) && ((state.editCargoLD3 || editRecord?.cargo?.ld3 || 0) >= p_ld3)) {
          if (editRecord?.fleet == '763' || editRecord?.fleet == '764') {
            if (p_ld3 == 0) {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            } else {
              Hint = 'Suboptimal Bin Configuration'
              className = 'table-row-danger'
            }
          }
          if (editRecord?.fleet == '332' && p_pmc > 0) {
            if (p_pmc % 2 == 0) {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            } else {
              Hint = 'Suboptimal Bin Configuration (The sum of PMC\'s and PAG\'s is not even)'
              className = 'table-row-danger'
            }
          }
          if (editRecord?.fleet == '333' && (p_pmc > 0 || p_pag > 0)) {
            let sub_opti = false
            if ((p_pmc + p_pag) % 2 != 0) {
              sub_opti = '(The sum of PMC\'s and PAG\'s is not even)'
            }
            if (!(p_pmc <= 6 && p_pag <= 2)) {
              sub_opti = '(Doesn\'t meet the criteria)'
            }
            if (sub_opti) {
              Hint = `Suboptimal Bin Configuration ${sub_opti}`
              className = 'table-row-danger'
            } else {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            }
          }
          if (editRecord?.fleet == '339' && (p_pmc > 0 || p_pag > 0)) {
            let sub_opti = false
            if ((p_pmc + p_pag) % 2 != 0) {
              sub_opti = '(The sum of PMC\'s and PAG\'s is not even)'
            }
            if (!((p_pmc == 6 && p_pag == 0) || (p_pmc <= 5 && p_pag <= 1))) {
              sub_opti = '(Doesn\'t meet the criteria)'
            }
            if (sub_opti) {
              Hint = `Suboptimal Bin Configuration ${sub_opti}`
              className = 'table-row-danger'
            } else {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            }
          }
          if (editRecord?.fleet == '359' && (p_pmc > 0 || p_pag > 0)) {
            let sub_opti = false
            if ((p_pmc + p_pag) % 2 != 0) {
              sub_opti = '(The sum of PMC\'s and PAG\'s is not even)'
            }
            if (!((p_pmc == 8 && p_pag == 0) || (p_pmc == 6 && p_pag == 0) || (p_pmc <= 5 && p_pag <= 1))) {
              sub_opti = '(Doesn\'t meet the criteria)'
            }
            if (sub_opti) {
              Hint = `Suboptimal Bin Configuration ${sub_opti}`
              className = 'table-row-danger'
            } else {
              Hint = 'Optimal Bin Configuration'
              className = 'table-row-success'
            }
          }
        } else {
          Hint = 'Planned exceeds Max bin configuration'
          className = 'table-row-warning'
        }
      }
    }
  }

  return [
    {
      key: '1',
      empty: 'Max Bin Configuration',
      PMC: state.editCargoP96 || editRecord?.cargo?.p96 || 0,
      PAG: state.editCargoP88 || editRecord?.cargo?.p88 || 0,
      LD2: state.editCargoLD2 || editRecord?.cargo?.ld2 || 0,
      LD3: state.editCargoLD3 || editRecord?.cargo?.ld3 || 0,
      Hint: state.hints || editRecord?.cargo?.hint,
      Notes: state.notes ||editRecord?.cargo?.note,
    },
    {
      key: '2',
      empty: 'Planned Bin Configuration',
      PMC: p_pmc,
      PAG: p_pag,
      LD2: p_ld2,
      LD3: p_ld3,
      Hint: Hint,
      Notes: '-',
      className
    },
    {
      key: '3',
      empty: 'Planned Bin Configuration',
      p96: p_pmc,
      p88: p_pag,
      ld2: p_ld2,
      ld3: p_ld3,
      Hint: Hint,
      Notes: '-',
      className
    }
  ]
}

export default get_bin_config